// 복약 시간유형(tkmdcnEraCd)별 기본 알림 시간: 1 아침, 2 점심, 3 저녁, 4 취침전, 5 기타
const PILL_ERA_TIME = {
    '1': { hour: 9, minute: 0 },
    '2': { hour: 13, minute: 0 },
    '3': { hour: 18, minute: 0 },
    '4': { hour: 21, minute: 0 },
    '5': { hour: 12, minute: 0 },
};

export const getPillEraTime = (eraCd) => PILL_ERA_TIME[eraCd] || PILL_ERA_TIME['5'];

export const toPillTm = ({ hour, minute }) =>
    `${String(hour).padStart(2, '0')}${String(minute).padStart(2, '0')}00`;

export const getPillEraTm = (eraCd) => toPillTm(getPillEraTime(eraCd));

// 알림 꺼진 채 저장된 090000 은 예전 기본값이라 유형별 기본시간으로 대체
export const getPillAlarmTime = ({ alrmSetupTm, alrmAt, tkmdcnEraCd } = {}) => {
    if (!alrmSetupTm || (alrmAt !== '1' && alrmSetupTm === '090000')) {
        return getPillEraTime(tkmdcnEraCd);
    }
    return {
        hour: parseInt(alrmSetupTm.substring(0, 2), 10),
        minute: parseInt(alrmSetupTm.substring(2, 4), 10),
    };
};
